export default __webpack_public_path__ + "static/media/arrival-banner-7.492ff1f2.jpg";